import React, { useState, useEffect } from 'react';

export default function NothingHere() {
    return (
        <main style={{ padding: "1rem" }}>
          <p>There's nothing here!</p>
        </main>
    )
}